import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Company } from '../../crm/models/company.model';

import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

export const loadCompany = createAction(
  '[Company] Load Company',
  props<{ limit?: number; offset?: number }>(),
);
export const cancelLoadCompanies = createAction(
  '[Company] Cancel Load Companies',
);
export const loadMoreCompany = createAction(
  '[Company] Load More Company',
  props<{ limit?: number; offset?: number }>(),
);

export const loadMoreCompanySuccess = createAction(
  '[Company] Load More Company Success',
  props<{ company: Company[] }>(),
);

export const selectCompany = createAction(
  '[Company] Select Company',
  props<{ id: number }>(),
);

export const loadCompanySuccess = createAction(
  '[Company] Load Company Success',
  props<{ company: Company[] }>(),
);

export const addCompany = createAction(
  '[Company] Add Company',
  props<{ company: Company; action?: 'continue' | 'close' | 'idle' }>(),
);

export const addCompanySuccess = createAction(
  '[Company] Add Company Success',
  props<{ company: Company }>(),
);

export const updateCompany = createAction(
  '[Company] Update Company',
  props<{ company: Company; id: number }>(),
);

export const updateCompanySuccess = createAction(
  '[Company] Update Company Success',
  props<{ company: Update<Company> }>(),
);

export const deleteCompany = createAction(
  '[Company] Delete Company',
  props<{ id: string }>(),
);

export const deleteCompanySuccess = createAction(
  '[Company] Delete Company Success',
  props<{ id: string }>(),
);

export const companyError = createAction(
  '[Company] Company Error',
  props<{ err: any }>(),
);

export const setCompanySearch = createAction(
  '[CRM] Set Company Search',
  props<{ search: string }>(),
);
export const setCompanySort = createAction(
  '[CRM] Set Company Sort',
  props<{ sortBy: SortBy }>(),
);
export const resetCompanyFilters = createAction('[CRM] Reset Filters');

export const ClearCompanies = createAction('[Company] Clear Companies');
